// Firebase Configuration menggunakan Environment Variables
// Untuk development, buat file .env di root project dengan variabel berikut:
// REACT_APP_FIREBASE_API_KEY=your_api_key
// REACT_APP_FIREBASE_AUTH_DOMAIN=your_auth_domain
// REACT_APP_FIREBASE_PROJECT_ID=your_project_id
// REACT_APP_FIREBASE_STORAGE_BUCKET=your_storage_bucket
// REACT_APP_FIREBASE_MESSAGING_SENDER_ID=your_messaging_sender_id
// REACT_APP_FIREBASE_APP_ID=your_app_id

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Firebase Configuration dari Environment Variables
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDNl9PPgXiDm4uGv3UkRXtnRwA0KWa9LYA",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "gurupintarai.firebaseapp.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "gurupintarai",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "gurupintarai.firebasestorage.app",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "478302963689",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:478302963689:web:e32e1f0e390b7fc9a52d78"
};

// Validasi bahwa config tidak kosong
if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
    console.warn('⚠️ Firebase configuration tidak lengkap. Pastikan environment variables sudah di-set dengan benar.');
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Connect to Emulators in development (localhost or local network IP)
if (window.location.hostname === 'localhost' || window.location.hostname.startsWith('192.168.')) {
    // Functions Emulator
    // Use 127.0.0.1 to avoid CORS/IPv6 issues with localhost
    connectFunctionsEmulator(functions, '127.0.0.1', 5001);

    // Storage Emulator
    // connectStorageEmulator(storage, window.location.hostname, 9199);

    console.log(`🔧 Connected to Emulators at ${window.location.hostname}`);
}

// Export appId untuk digunakan di seluruh aplikasi
export const appId = firebaseConfig.projectId;

// Export Firebase services
export { app, auth, db, storage, functions };

// Export default untuk backward compatibility
export default {
    app,
    auth,
    db,
    storage,
    functions,
    appId
};

